/** Backend plugin id used for discovery. @public */
export const DEVOPS_SECRETS_STORAGE_PLUGIN_ID = 'devops-secrets-storage';

/** API path prefix for secrets-storage backend. @public */
export const SECRETS_STORAGE_API_PREFIX = 'v1';
